// src/utils/gamificationConfig.js

// Importy ikon
import JajoIcon from '../img/icons/jajo.png';
import JajoSzaryIcon from '../img/icons/jajo_szary.png';
import PisklakIcon from '../img/icons/pisklak.png';
import PisklakSzaryIcon from '../img/icons/pisklak_szary.png';
import OrzelekIcon from '../img/icons/orzelek.png';
import OrzelekSzaryIcon from '../img/icons/orzelek_szary.png';
import MieczIcon from '../img/icons/miecz.png';
import MieczSzaryIcon from '../img/icons/miecz_szary.png';

// 1. Definicja poziomów (Nazwy, Ikony, Opisy) - TO ZOSTAJE NA FRONCIE
export const LEVEL_DEFINITIONS = [
    { 
        name: "Jajo", 
        icon: { achieved: JajoIcon, notAchieved: JajoSzaryIcon },
        description: "Jesteś na początku swojej drogi do sukcesu, ale już dokonałeś znaczących postępów - tak trzymaj!"
    },
    { 
        name: "Pisklak", 
        icon: { achieved: PisklakIcon, notAchieved: PisklakSzaryIcon },
        description: "Potrafisz poradzić sobie z większością łatwych zadań i pewniaczków - to świetna baza do dalszego rozwoju!"
    },
    { 
        name: "Orzełek", 
        icon: { achieved: OrzelekIcon, notAchieved: OrzelekSzaryIcon },
        description: "Dobrze radzisz sobie nawet z trudniejszymi i bardziej skomplikowanymi zadaniami - oby tak dalej, a zdasz maturę bez problemu!"
    },
    { 
        name: "Łowca zadań", 
        icon: { achieved: MieczIcon, notAchieved: MieczSzaryIcon },
        description: "Nawet najtrudniejsze zadania nie stanowią dla Ciebie problemu, a na maturze dasz sobie radę nawet z zamkniętymi oczami!"
    },
];

// 2. FALLBACK — zsynchronizowany z wartościami API
const FALLBACK_DEFAULTS = {
    "Jajo":        { elo: 50, tasks: 5 },
    "Pisklak":     { elo: 200, tasks: 30 },
    "Orzełek":     { elo: 400, tasks: 60 },
    "Łowca zadań": { elo: 700, tasks: 100 },
};

// 3. MODULE-LEVEL CACHE — przeżywa cały lifecycle apki w pamięci
let _cachedConfig = null;

export const setGamificationConfig = (appConfig) => {
    _cachedConfig = appConfig;
};

// 4. SINGLE SOURCE OF TRUTH: czy field ma daną rangę (ELO + zadania)
export const hasRank = (field, rankName) => {
    if (!field || !rankName) return false;
    const t = getThresholdsForField(field.field_id);
    const req = t[rankName];
    if (!req) return false;
    return (field.user_field_elo || 0) >= req.elo
        && (field.total_solved_per_field || 0) >= req.tasks;
};

// 5. FUNKCJA POBIERAJĄCA PROGI
export const getThresholdsForField = (fieldId) => {
    try {
        // PRIORYTET 1: In-memory cache (zawsze dostępny po initializeApp)
        let gamification = _cachedConfig?.gamification_config;

        // PRIORYTET 2: localStorage jako fallback (np. hot reload w dev)
        if (!gamification) {
            const configRaw = localStorage.getItem('global_config');
            if (configRaw) {
                const config = JSON.parse(configRaw);
                gamification = config?.gamification_config;
                // Przy okazji napełnij cache, żeby następne odczyty szły z pamięci
                if (config) _cachedConfig = config;
            }
        }

        // PRIORYTET 3: Hardcoded fallback
        if (!gamification) return FALLBACK_DEFAULTS;

        // Sprawdź field-specific config.
        // Zawsze mergujemy z FALLBACK_DEFAULTS, żeby KAŻDA nazwa poziomu z LEVEL_DEFINITIONS
        // miała próg (config z API bywa niekompletny -> inaczej thresholds[name] = undefined
        // i render rangi rzuca wyjątek).
        if (gamification.field_specific && gamification.field_specific[String(fieldId)]) {
            return { ...FALLBACK_DEFAULTS, ...gamification.field_specific[String(fieldId)] };
        }

        return { ...FALLBACK_DEFAULTS, ...(gamification.default_thresholds || {}) };

    } catch (error) {
        console.error("Błąd odczytu konfiguracji gry:", error);
        return FALLBACK_DEFAULTS;
    }
};